import * as api from '@/api/api';
export const uploadUrl = api.BaseApiUrl + "/UploadFile/Upload"